<template>
	<div
		ref="screenshot"
		class="screenshot"
		v-if="selectedScreenshot"
	>
		<div class="toggles">
			<span
				v-for="(view, index) in filteredViews"
				:key="index"
			>
				<a
					class="toggle"
					@click.prevent="selectedView = index"
					:class="{ active: selectedView === index }"
					href="#"
				>
					{{ view }}
				</a>
			</span>
		</div>
		<div
			class="image"
			:style="{
				width: imageWidth,
				height: imageHeight
			}"
		>
			<transition
				name="component-fade-screenshots"
				mode="out-in"
			>
				<img
					v-if="!campaign.is_mobile"
					:key="selectedView"
					:src="getScreenshotUrl(screenshotUrl)"
				/>
				<div
					v-if="campaign.is_mobile"
					class="mobile-preview"
					:key="selectedView"
				>
					<img
						:src="screenshotUrl"
						:class="campaign.type"
					/>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	props : {
		campaign : {
			type     : Object,
			required : true,
		},
	},
	data () {
		return {
			imageWidth  : '100%',
			imageHeight : 'auto',
			setView     : null,
			views       : {
				yesno   : 'Yes/No',
				optin   : 'Optin',
				success : 'Success',
			},
		}
	},
	watch : {
		campaign (newValue) {
			this.resetCampaignNumbers()
			this.getScreenshotImageDimensions()
		},
		selectedView () {
			this.getScreenshotImageDimensions()
		},
	},
	computed : {
		selectedView : {
			get () {
				const defaultView = this.filteredViews['yesno'] ? 'yesno' : 'optin'
				return this.setView ? this.setView : defaultView
			},
			set (newValue) {
				this.setView = newValue
			},
		},
		filteredViews () {
			const filtered = {}
			Object.keys(this.views)
				.filter(view => this.campaign && this.campaign.screenshot_urls && this.campaign.screenshot_urls[view])
				.forEach(view => {
					filtered[view] = this.views[view]
				})

			return filtered
		},
		selectedScreenshot () {
			return this.campaign.screenshot_urls && this.campaign.screenshot_urls[this.selectedView]
				? this.campaign.screenshot_urls[this.selectedView]
				: ''
		},
		screenshotUrl () {
			return this.selectedScreenshot ? this.$urls.cdn(this.selectedScreenshot) : ''
		},
	},
	methods : {
		getScreenshotImageDimensions (wait = 300) {
			setTimeout(() => {
				if (this.$refs.screenshot && this.selectedScreenshot) {
					const maxWidth = 'Slide-in' === this.campaign.type || this.campaign.is_mobile ? '300' : this.$refs.screenshot.offsetWidth
					let img = new Image()
					img.onload = () => {
						const height = this.campaign.is_mobile ? 70 : 0
						this.imageWidth = maxWidth + 'px'
						this.imageHeight = (this.campaign.is_mobile ? 644 : (Math.round(img.height * maxWidth / img.width) + height)) + 'px'
					}
					img.src = this.$urls.cdn(this.getScreenshotUrl(this.selectedScreenshot))
				}
			}, 300)
		},
		getScreenshotUrl (url) {
			return `${url}?ver=${this.$moment(this.campaign.updated, 'YYYY-MM-DD HH:mm:ss').unix()}`
		},
		resizeScreenshot () {
			return this.getScreenshotImageDimensions(0)
		},
		resetCampaignNumbers () {
			this.setView     = null
			this.imageWidth  = '100%'
			this.imageHeight = 'auto'
		},
	},
	mounted () {
		this.getScreenshotImageDimensions()
		window.addEventListener('resize', this.resizeScreenshot)
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.resizeScreenshot)
	},
}
</script>

<style lang="scss">
@import '../../assets/scss/variables';
.content {
	.screenshot {
		margin: 20px 0 25px;

		.toggles {
			text-align: center;
			padding-bottom: 20px;
			font-size: 12px;
			font-weight: 600;

			span {
				display: inline-block;

				a {
					text-decoration: none;
					border: 1px solid $color_grey-border;
					border-right: none;
					padding: 7px 10px;
					display: block;

					&:hover,
					&.active {
						background-color: $color_blue-primary;
						color: #fff;
						border-color: $color_blue-primary;
						text-decoration: none;
					}
				}

				&:last-child {
					a {
						border-right: 1px solid $color_grey-border;
						border-top-right-radius: 3px;
						border-bottom-right-radius: 3px;

						&:hover,
						&.active {
							border-color: $color_blue-primary;
						}
					}
				}

				&:first-child {
					a {
						border-top-left-radius: 3px;
						border-bottom-left-radius: 3px;
					}
				}
			}
		}

		.image {
			text-align: center;
			margin-bottom: 20px;
			transition: height 0.3s ease;
			overflow: hidden;
			margin: 0 auto;

			img {
				width: 100%;
				height: auto;
			}

			.mobile-preview {
				width: 300px;
				height: 644px;
				margin: 0 auto;
				background: #fff;
				border-top: 50px solid #41495B;
				border-bottom: 50px solid #41495B;
				border-left: 10px solid #41495B;
				border-right: 10px solid #41495B;
				border-radius: 10px;
				display: flex;

				img {
					display: inherit;
				}
			}
		}
	}
}
</style>
